import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './shared/providers/auth-guard.component';

import { PageNotFound } from './shared/components/pageNotFound/page-not-found.component';
import { unauthorizePage } from './shared/components/unauthorizePage/unauthorize-page.component';

import { ModuleWithProviders } from '@angular/core';
import { Configuration } from './shared/configurations/shared.config';
import { HomeComponent } from './shared/components/Home/home.component';

export const appRoutes: Routes = [
    { path: 'login', redirectTo: 'users/login', pathMatch: 'full' },
    {
        path: '',
        component: HomeComponent,
        pathMatch: 'full'
    },
    {
        path: Configuration.modulePrefixes.adminLanding,
        loadChildren: './adminLanding/adminLanding.module#AdminLandingModule',
        canActivate: [AuthGuard]
    },
    {
        path: Configuration.modulePrefixes.administration,
        loadChildren: './administration/administration.module#AdministrationModule',
        canActivate: [AuthGuard]
    },
    {
        path: Configuration.modulePrefixes.trackingAndMonitoring,
        loadChildren: './trackingAndMonitoring/tracking-and-monitoring.module#TrackingAndMonitoringModule',
        canActivate: [AuthGuard]
    },
    {
        path: Configuration.modulePrefixes.operations,
        loadChildren: './operations/operations.module#OperationsModule',
        canActivate: [AuthGuard]
    },
    {
        path: Configuration.modulePrefixes.resourceManagement,
        loadChildren: './resourceManagement/resource-management.module#ResourceManagmentModule',
        canActivate: [AuthGuard]
    },
    {
        path: Configuration.modulePrefixes.analytics,
        loadChildren: './analytics/analytics.module#AnalyticsModule',
        //  canActivate: [AuthGuard]
    },
    {
        path: Configuration.modulePrefixes.accountManagement,
        loadChildren: './accountManagement/account-management.module#AccountManagementModule'
        // ,canActivate: [AuthGuard]
    },
    {
        path: Configuration.modulePrefixes.reportsAndLogs,
        loadChildren: './reportsAndLogs/reports-and-logs.module#ReportsAndLogsModule',
        canActivate: [AuthGuard]
    },
    {
        path: Configuration.modulePrefixes.subscriberUsers,
        loadChildren: './subscriberUsers/subscriber-users.module#SubscriberUsersModule',
        canActivate: [AuthGuard]
    },
    {
        path: Configuration.modulePrefixes.devices,
        loadChildren: './devices/devices.module#DevicesModule',
        canActivate: [AuthGuard]
    },

    {
        path: Configuration.modulePrefixes.maintenance,
        loadChildren: './maintenance/maintenance.module#MaintenanceModule',
        canActivate: [AuthGuard]
    },

    {
        path: 'technicalsupport',
        loadChildren: './administration/components/technicalSupportOrders/technicalsupport.module#TechnicalSupportModule',
        canActivate: [AuthGuard]
    },
    //{
    //path: Configuration.modulePrefixes.maintenance,
    //loadChildren: './devices/devices.module#DevicesModule',
    // canActivate: [AuthGuard]
    //},


    {
        path: 'unauthorize',
        component: unauthorizePage
    },
    {
        path: '**',
        component: PageNotFound
    },

];
export const AppModuleRouting: ModuleWithProviders = RouterModule.forRoot(appRoutes /*, { enableTracing: true } */);


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/app.routes.ts